import { BuyGuideVendorDocumentList } from '../../../components/BuyGuide';

export function BuyGuideVendorDocuments() {
  return <BuyGuideVendorDocumentList />;
}
